<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">

                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <div class="col mb-3">
                                <TheInputText title="Tên" placeholder="Tìm theo tên" v-model="modelSearch.ten"
                                    :isRequire=false @onChange="v => handlePageChange(1)" />
                            </div>
                        </div>
                        <div class="col mb-3">
                            <div class="col mb-3">
                                <TheInputText title="STT báo cáo" placeholder="Tìm theo STT báo cáo"
                                    v-model="modelSearch.sttBaocao" :isRequire=false :key="tempKey"
                                    @onChange="v => handlePageChange(1)" />
                            </div>
                        </div>
                        <div class="col mb-3">

                            <div class="col mb-3">
                                <TheSelect4 title="Nguồn vốn đầu tư" :options="category_NGUONVONDAUTU"
                                    v-model:initialValue="modelSearch.nguonvonDautuId" :isMultiple="false"
                                    :isAllowClear="true" :isRequire="false"
                                    @onChange="(e) => { modelSearch.nguonvonDautuId = e ? e : null; handlePageChange(1) }" /> 
                            </div>
                        </div>
                        <div class="col mb-3">

                            <div class="col mb-3">
                                <TheSelect4 title="Dự án đầu tư liên quan" :options="category_DUANDAUTU"
                                    v-model:initialValue="modelSearch.duanDautuLienquanId" :isMultiple="false"
                                    :isAllowClear="true" :isRequire="false" 
                                    @onChange="(e) => { modelSearch.duanDautuLienquanId = e ? e : null; handlePageChange(1) }" />
                            </div>
                        </div>
                        <div class="col mb-3">
                            <div class="col mb-3">
                                <TheSelect title="Tiến độ đầu tư" :options="category_TIENDODAUTU"
                                    :initialValue="modelSearch.tiendoDautuId" :isMultiple="false" :isAllowClear="true"
                                    :isRequire="false" 
                                    @onChange="(e) => { modelSearch.tiendoDautuId = e ? e : null; handlePageChange(1) }" />
                            </div>
                        </div>
                        <div class="col mb-3">
                            <div class="col mb-3">
                                <TheInputText title="Chủ đầu tư" placeholder="Tìm theo chủ đầu tư"
                                    v-model="modelSearch.chuDautu" :isRequire=false :key="tempKey"
                                    @onChange="v => handlePageChange(1)" />
                            </div>
                        </div>
                        <div class="col mb-3">
                            <TheDateRangePicker title="Thời gian bắt đầu" placeholder="Tìm theo thời gian bắt đầu"
                                v-model:startDate="modelSearch.thoigianBatdauTungay"
                                v-model:endDate="modelSearch.thoigianBatdauDenngay" :error="''" :isReadOnly="false"
                                :isRequire="false" :key="tempKey"
                                @onChange="(e) => { handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheDateRangePicker title="Thời gian kết thúc" placeholder="Tìm theo thời gian kết thúc"
                                v-model:startDate="modelSearch.thoigianKetthucTungay"
                                v-model:endDate="modelSearch.thoigianKetthucDenngay" :error="''" :isReadOnly="false"
                                :isRequire="false" :key="tempKey"
                                @onChange="(e) => { handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(e) => { modelSearch.enabled = e; handlePageChange(1) }" />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </section>

    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="currentSearchType == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="currentSearchType == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <TheSwapButton v-model="currentSearchType" @button-clicked="handlePageChange(1)" />
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.RESTORE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.RESTORE] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.DELETE_TEMP" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE_TEMP] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.DELETE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE] :isDivider="true">
                                    </TheButtonInDropdown>

                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.ON_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.ON_ENABLED] :isDivider="false">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.OFF_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.OFF_ENABLED] :isDivider="true">
                                    </TheButtonInDropdown>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, navigateCode.CREATE)"
                            v-bind:title="$t('buttons.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th style="width:5%">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="cursor col" style="width:5%" @click="handleSortChange('duanDautuId')" title="Sắp xếp theo ID">
                                        ID
                                        <span v-if="sortBy == 'duanDautuId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('sttBaocao')"  title="Sắp xếp theo STT báo cáo">
                                        STT báo cáo
                                        <span v-if="sortBy == 'sttBaocao'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-3 cursor" @click="handleSortChange('ten')" title="Sắp xếp theo tên">
                                        Tên
                                        <span v-if="sortBy == 'ten'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-2 cursor" @click="handleSortChange('tenNguonvonDautu')" title="Sắp xếp theo nguồn vốn đầu tư">
                                        Nguồn vốn đầu tư
                                        <span v-if="sortBy == 'tenNguonvonDautu'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-2 cursor" @click="handleSortChange('tenTiendoDautu')" title="Sắp xếp theo tiến độ đầu tư">
                                        Tiến độ đầu tư
                                        <span v-if="sortBy == 'tenTiendoDautu'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1 cursor" @click="handleSortChange('thoigianBatdau')">
                                        Thời gian bắt đầu
                                        <span v-if="sortBy == 'thoigianBatdau'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col-1 cursor" @click="handleSortChange('thoigianKetthuc')">
                                        Thời gian kết thúc
                                        <span v-if="sortBy == 'thoigianKetthuc'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col-1 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="sortBy == 'stt'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">Hiển thị trên cổng</th>
                                    <!-- <th class="col50">Đồng bộ từ IOC tỉnh</th> -->
                                    <th class="col-1 sticky-action">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.duanDautuId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span v-if="(csList_Navigate.csList.includes(item.duanDautuId))" class="text-primary">&check;</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                    </td>
                                    <td>{{ item.duanDautuId }}</td>
                                    <td>{{ item.sttBaocao }}</td>
                                    <td>
                                        <p style="margin-bottom: 5px;"> {{ item.ten }}</p>
                                        <span v-if="item.chuDautu"><strong>Chủ đầu tư: </strong>{{ item.chuDautu
                                            }}</span><br />
                                        <span v-if="item.tenDuanDautuLienquan"><strong>Dự án liên quan: </strong>{{
                                            item.tenDuanDautuLienquan
                                            }}</span>
                                    </td>
                                    <td>{{ item.tenNguonvonDautu }}</td>
                                    <td>{{ item.tenTiendoDautu }}</td>
                                    <td>{{ item.thoigianBatdau }}</td>
                                    <td>{{ item.thoigianKetthuc }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <TheSwitchInTable 
                                        :placeholder="'Thay đổi hiển thị trên cổng '"
                                        v-model:initialValue="item.enabled" 
                                        :isReadOnly="currentSearchType == typeDataList.DELETED_LIST.id"
                                        :onChange="(e) => { navigateEnabledChange(item.duanDautuId, e.target.checked) }"
                                        ></TheSwitchInTable>
                                    </td>
                                    <td class="sticky-action">
                                        <TheButtonInTable
                                            v-model="tableButton.VIEWDETAIL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DETAIL]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.EDIT" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.UPDATE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.DELETE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE_TEMP]">
                                        </TheButtonInTable>
                                        
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.DELETE_REAL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.RESTORE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.RESTORE]">
                                        </TheButtonInTable>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" idModal="crudModal" dialogClass="modal-75vw" :headerTitle="title"
        :displaySubmit="loadingSubmit" :onSubmit="handleSubmit" :titleSubmit="title" :styleButton="styleButton"
        v-model:showModalFlag="isShowModal.CRUDModal">

        <div class="row">
            <div class="modal-box">
                <div class="header-box no-dropdown">
                    <div class="title-box"><i class="fas fa-caret-right"></i> <b>Thông tin dự án đầu tư:</b></div>
                </div>

                <div class="modal-box-content">
                    <div class="row">
                        <div class="col-md-8">
                            <TheInputText title="Tên dự án đầu tư" placeholder="Nhập tên dự án đầu tư"
                                :initialValue="model.ten" v-model="model.ten" :error="errors.ten"
                                :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheSelect4 title="Dự án đầu tư liên quan" :options="category_DUANDAUTU"
                                :initialValue="model.duanDautuLienquanId" :error="errors.duanDautuLienquanId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { model.duanDautuLienquanId = e }" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-md-4">
                            <TheInputText title="Chủ đầu tư" placeholder="Nhập chủ đầu tư"
                                :initialValue="model.chuDautu" v-model="model.chuDautu" :error="errors.chuDautu"
                                :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>

                        <div class="col-md-4">
                            <TheDatePicker title="Thời gian bắt đầu" placeholder="Chọn thời gian bắt đầu"
                                :initialValue="model.thoigianBatdau" v-model="model.thoigianBatdau"
                                :error="errors.thoigianBatdau" :isReadOnly="isReadOnly" :isRequire="false"
                                :key="tempKey" @onChangeDate="(d) => { model.thoigianBatdau = d }" />
                        </div>
                        <div class="col-md-4">
                            <TheDatePicker title="Thời gian kết thúc" placeholder="Chọn thời gian kết thúc"
                                :initialValue="model.thoigianKetthuc" v-model="model.thoigianKetthuc"
                                :error="errors.thoigianKetthuc" :isReadOnly="isReadOnly" :isRequire="false"
                                :key="tempKey" @onChangeDate="(d) => { model.thoigianKetthuc = d }" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <TheSelect4 title="Nguồn vốn đầu tư" :options="category_NGUONVONDAUTU"
                                :initialValue="model.nguonvonDautuId" :error="errors.nguonvonDautuId"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.nguonvonDautuId = e }" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheSelect title="Tiến độ đầu tư" :options="category_TIENDODAUTU"
                                :initialValue="model.tiendoDautuId" :error="errors.tiendoDautuId" :isMultiple="false"
                                :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.tiendoDautuId = e }" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheInputText title="Tổng mức đầu tư" placeholder="Nhập tổng mức đầu tư"
                                :initialValue="model.tongmucDautu" v-model="model.tongmucDautu"
                                :error="errors.tongmucDautu" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Tình hình triển khai" placeholder="Nhập tình hình triển khai"
                                :initialValue="model.tinhhinhTrienkhai" v-model="model.tinhhinhTrienkhai"
                                :error="errors.tinhhinhTrienkhai" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="true" :isSummerNote="true" :key="tempKey" />
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <TheInputText title="STT danh sách" placeholder="Nhập STT danh sách" :initialValue="model.stt"
                                v-model="model.stt" :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheInputText title="STT báo cáo" placeholder="Nhập STT báo cáo"
                                :initialValue="model.sttBaocao" v-model="model.sttBaocao" :error="errors.sttBaocao"
                                :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheSwitchButton  title="Hiển thị trên cổng" placeholder="Chọn hiển thị trên cổng" :isReadOnly="isReadOnly" :isRequire=false :key="tempKey" :error="''" v-model:initialValue="model.enabled"> </TheSwitchButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="modal-box">
                <div class="header-box no-dropdown">
                    <div class="title-box"><i class="fas fa-caret-right"></i> <b>Thông tin Kế hoạch vốn đầu
                            tư:</b></div>
                </div>

                <div class="modal-box-content">
                    <div class="row">
                        <div class="col-md-3">
                            <TheSelect title="Năm kế hoạch vốn" :options="category_KYKEHOACHVON"
                                :initialValue="model.KHV_idKy" :error="errors.KHV_idKy" :isMultiple="false"
                                :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.KHV_idKy = e }" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Vốn năm trước chuyển sang" placeholder="Nhập vốn năm trước chuyển sang"
                                :initialValue="model.KHV_namtruocChuyensang" v-model="model.KHV_namtruocChuyensang"
                                :error="errors.KHV_namtruocChuyensang" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>

                        <div class="col-md-3">
                            <TheInputText title="Vốn phân khai trong năm" placeholder="Nhập vốn phân khai trong năm"
                                :initialValue="model.KHV_vonphankhaiTrongnam" v-model="model.KHV_vonphankhaiTrongnam"
                                :error="errors.KHV_vonphankhaiTrongnam" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="Ước vốn năm trước chuyển sang" placeholder="Nhập ước vốn năm trước chuyển sang"
                                :initialValue="model.KHV_uocnamtruocChuyensang"
                                v-model="model.KHV_uocnamtruocChuyensang" :error="errors.KHV_uocnamtruocChuyensang"
                                :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-12">
                            <TheInputText title="Ghi chú" placeholder="Nhập ghi chú kế hoạch vốn"
                                :initialValue="model.KHV_ghiChu" v-model="model.KHV_ghiChu" :error="errors.KHV_ghiChu"
                                :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="code != navigateCode.CREATE">
            <div class="modal-box">
                <div class="header-box no-dropdown">
                    <div class="title-box"><i class="fas fa-list"></i> <b>Danh sách Kế hoạch vốn đầu
                            tư hiện tại:</b></div>
                </div>
                <div class="modal-box-content">
                    <div class="table-responsive p-0">
                        <table class="table table-hover" id="table">
                            <thead>
                                <th class="col20">Ngày cập nhật</th>
                                <th class="col20">Năm</th>
                                <th class="col50">Năm trước chuyển sang</th>
                                <th class="col50">Vốn phân khai trong năm</th>
                                <th class="col50">Ước năm trước chuyển sang</th>
                            </thead>
                            <tbody>
                                <tr v-for="item in model.kehoachVonInfo" :key="item._id">
                                    <td>{{ item.ngay }}</td>
                                    <td>{{ item.tenKy }}</td>
                                    <td>{{ item.namtruocChuyensang }}</td>
                                    <td>{{ item.vonphankhaiTrongnam }}</td>
                                    <td>{{ item.uocnamtruocChuyensang }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>

    </TheCRUDFrameModal>


    <TheDetailFrameModal ref="modalDetailRef" idModal="detailModal" dialogClass=" modal-75vw"
        :headerTitle="$t('labels.itemDetails')" v-model:showModalFlag="isShowModal.detailModal">
        <div class="row" v-if="modelRec">
            <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">ID:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.duanDautuId }}&nbsp;</b>
                </p>
                <p class="text-sm">STT báo cáo:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.sttBaocao }}&nbsp;</b>
                </p>
                <p class="text-sm">Tên:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ten }}&nbsp;</b>
                </p>
                <p class="text-sm">Dự án đầu tư liên quan:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenDuanDautuLienquan }}&nbsp;</b>
                </p>
                <p class="text-sm">STT:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                </p>
                <p class="text-sm">Hiển thị trên cổng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                        }}&nbsp;</b>
                </p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                <p class="text-sm">Nguồn vốn đầu tư:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;&nbsp;{{ modelRec.tenNguonvonDautu }}</b>
                </p>
                <p class="text-sm">Tiến độ đầu tư:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;&nbsp;{{ modelRec.tenTiendoDautu }}</b>
                </p>
                <p class="text-sm">Chủ đầu tư:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;&nbsp;{{ modelRec.chuDautu }}</b>
                </p>
                <p class="text-sm">Tổng mức đầu tư:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tongmucDautu }}&nbsp;</b>
                </p>
                <p class="text-sm">Thời gian bắt đầu:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;&nbsp;{{ modelRec.thoigianBatdau }}</b>
                </p>
                <p class="text-sm">Thời gian kết thúc:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;&nbsp;{{ modelRec.thoigianKetthuc }}</b>
                </p>
            </div>
        </div>
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <div class="modal-box">
                    <div class="header-box no-dropdown">
                        <div class="title-box"><i class="fas fa-tasks"></i> <b>Tình hình triển khai:</b></div>

                    </div>
                    <div class="modal-box-content">
                        <span id="tinhHinhTrienKhai_Detail"></span>
                    </div>
                </div>

            </div>
        </div>
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <div class="modal-box">
                    <div class="header-box no-dropdown">
                        <div class="title-box"><i class="fas fa-list"></i> <b>Danh sách Kế hoạch vốn đầu
                                tư:</b></div>
                    </div>
                    <div class="modal-box-content">
                        <div class="table-responsive p-0">
                            <table class="table table-hover" id="table">
                                <thead>
                                    <th class="col20">Ngày cập nhật</th>
                                    <th class="col20">Năm</th>
                                    <th class="col50">Năm trước chuyển sang</th>
                                    <th class="col50">Vốn phân khai trong năm</th>
                                    <th class="col50">Ước năm trước chuyển sang</th>
                                </thead>
                                <tbody>
                                    <tr v-for="item in modelRec.kehoachVonInfo" :key="item._id">
                                        <td>{{ item.ngay }}</td>
                                        <td>{{ item.tenKy }}</td>
                                        <td>{{ item.namtruocChuyensang }}</td>
                                        <td>{{ item.vonphankhaiTrongnam }}</td>
                                        <td>{{ item.uocnamtruocChuyensang }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </TheDetailFrameModal>

    <TheConfirmDialogModal :title="csList_MapModel.title"
        :confirmLabelButton="csList_MapModel.confirmLabelButton" :onClose="csList_MapModel.onClose"
        :onSubmit="csList_MapModel.onSubmit" :modalContent=csList_MapModel.modalContent
        :isReConfirm=csList_MapModel.isReConfirm :reConfirmMes=csList_MapModel.reConfirmMes
        v-model:showModalFlag="isShowModal.confirmDialogModal"></TheConfirmDialogModal>
    <TheCheckboxConfirmDialogModal :title="csListEnabled_MapModel.title"
        :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton"
        :onClose="csListEnabled_MapModel.onClose" :onSubmit="csListEnabled_MapModel.onSubmit"
        :modalContent=csListEnabled_MapModel.modalContent :key="tempKey"
        :submitArgs="csListEnabled_MapModel.submitArgs" v-model="checkEnable_Memo"
        v-model:showModalFlag="isShowModal.checkBoxConfirmModal">
    </TheCheckboxConfirmDialogModal>
</template>
<script>

import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import tableValue from '@/config/table.env'
import objectDefaultValue from '@/config/object.env'
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import { read, utils, writeFileXLSX } from 'xlsx';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheSelect4 from '@/components/shareComponents/TheSelect4.vue';
import TheConfirmDialog from '@/components/shareComponents/TheConfirmDialog.vue'
import TheDateRangePicker from '@/components/shareComponents/TheDateRangePicker.vue'

import TheDatePicker from '@/components/shareComponents/TheDatePicker.vue'
import TheCheckboxConfirmDialog from '@/components/shareComponents/TheCheckboxConfirmDialog.vue'

import TheSwapButton from '@/components/shareComponents/table/button/TheSwapButton.vue'
import TheSwitchButton from '@/components/shareComponents/TheSwitchButton.vue'
import TheSwitchInTable from '@/components/shareComponents/table/switch/TheSwitchInTable.vue'
import TheButtonInDropdown from '@/components/shareComponents/table/button/TheButtonInDropdown.vue'
import TheButtonInTable from '@/components/shareComponents/table/button/TheButtonInTable.vue'

import { tableInteractiveModel } from '@/models/general/tableInteractive.model'
import { duanDautuModel } from '@/models/taichinhkehoach/duanDautu.model'
import { kehoachVonModel } from '@/models/taichinhkehoach/kehoachVon.model'

import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'

import TheCheckboxConfirmDialogModal from '@/components/shareComponents/modal/TheCheckboxConfirmDialogModal.vue'
import TheConfirmDialogModal from '@/components/shareComponents/modal/TheConfirmDialogModal.vue'

export default {
    name: "TheDuAnDauTu",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheSelect4,
        TheConfirmDialog,
        TheCheckboxConfirmDialog,
        TheDateRangePicker,
        TheDatePicker,
        TheDetailFrameModal,
        TheCRUDFrameModal,

        TheSwapButton,
        TheButtonInDropdown,
        TheButtonInTable,
        TheSwitchButton,
        TheSwitchInTable,
        TheCheckboxConfirmDialogModal,
        TheConfirmDialogModal,
    },

    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            modelRec: duanDautuModel.newModel(),
            model: duanDautuModel.newFEModel(),
            errors: duanDautuModel.errors(),
            modelSearch: duanDautuModel.newPagingSearchModel(),

            cEnable_Value: null,


            csList_Code: null,
            checkEnable_Memo: false,

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,
            category_NGUONVONDAUTU: [],
            category_TIENDODAUTU: [],
            category_DUANDAUTU: [],
            category_KYKEHOACHVON: [],
            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            isShowModal: {
                CRUDModal: false,
                detailModal: false,
                checkBoxConfirmModal: false,
                confirmDialogModal: false,
            },
            loadingSubmit: false,

            tempKey: common.randomString(10),
            modelKeHoachVon: kehoachVonModel.newModel(),

            currentSearchType: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,
            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            tableButton: objectDefaultValue.TABLEBUTTON,
        }
    },

    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('handleData2', ['handleChangeType',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber', 'validateFloat'],),
        ...mapActions('duanDautu', ['getPagingDuanDautu', 'getDetailDuanDautu', 'checkExistDuanDautu', 'createDuanDautu', 'updateDuanDautu', 'deleteDuanDautu', 'restoreDuanDautu', 'handleListDuanDautu', 'setEnabledDuanDautu', 'getBasicDuanDautu', 'getCustomDetailInfoDuanDautu']),
        ...mapActions('nguonvonDautu', ['getBasicCustomNguonvonDautu', 'getBasicTreeNguonvonDautu']),
        ...mapActions('tiendoDautu', ['getBasicTiendoDautu']),
        ...mapActions('dmKy', ['getBasicDMKy']),
        ...mapActions('kehoachVon', ['createKehoachVon']),


        async setup() {
            let header = 'Danh sách dự án đầu tư'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_NGUONVONDAUTU = await this.getCategory_NguonVonDauTu()
            this.category_TIENDODAUTU = await this.getCategory_TienDoDauTu()
            this.category_DUANDAUTU = await this.getCategory_DuAnDauTu()
            this.category_KYKEHOACHVON = await this.getCategory_KyKeHoachVon()

        },

        //#region TableNavigation
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },

        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.isShowModal.checkBoxConfirmModal = true
        },

        async navigateEnabledChange(id,  value) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                this.updateEnabled()
            }
        },

        async updateEnabled() {
            let model = {
                duanDautuId: this.cEnable_Item.id,
                enabled: this.cEnable_Item.enabled
            }
            await this.setEnabledDuanDautu({ model: model }).then(async resp => {
                if (resp) {
                    this.isShowModal.checkBoxConfirmModal = false
                }
                else {
                    const itemIndex = this.items.findIndex(item => item.duanDautuId === this.cEnable_Item.id);
                    if (itemIndex !== -1) {
                        this.items[itemIndex].enabled = !this.items[itemIndex].enabled;

                    } else {
                        await this.getData()
                    }
                }

            });
        },

        async closeConfirmEnabledChange() {
            const itemIndex = this.items.findIndex(item => item.duanDautuId === this.cEnable_Item.duanDautuId);
            if (itemIndex !== -1) {
                this.items[itemIndex].enabled = !this.items[itemIndex].enabled;
            } else {
                await this.getData()
            }
            this.isShowModal.checkBoxConfirmModal = false
        },

        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },

        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },

        async unSelectAllRows() {
            this.csList_Navigate.csList = []
            document.getElementById("checkboxAll").checked = false
        },

        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.duanDautuId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },

        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            if (this.modelSearch.ten == "") this.modelSearch.ten = null
            if (this.modelSearch.chuDautu == "") this.modelSearch.chuDautu = null
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
        },

        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()

            await this.getPagingDuanDautu({ params: this.modelSearch, type: this.currentSearchType }).then(res => {
                // List data
                this.items = res.data

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },
        //#endregion TableNavigation

        //#region CRUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = duanDautuModel.errors()

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    duanDautuId: item.duanDautuId
                }
                let resp = await this.getCustomDetailInfoDuanDautu({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = duanDautuModel.newModel()
                        this.modelRec = resp
                        this.model = duanDautuModel.parseModeltoFEModel(this.modelRec.detailInfo)
                        this.model.kehoachVonInfo = this.modelRec.kehoachVonInfo
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true


            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    duanDautuId: item.duanDautuId
                }
                await this.getCustomDetailInfoDuanDautu({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = duanDautuModel.newModel()
                        this.modelRec = resp.detailInfo
                        this.modelRec.kehoachVonInfo = resp.kehoachVonInfo || []
                        if (this.modelRec.tinhhinhTrienkhai) {
                            let contentDiv = document.getElementById('tinhHinhTrienKhai_Detail');
                            contentDiv.innerHTML = this.modelRec.tinhhinhTrienkhai;
                        }
                        else {
                            let contentDiv = document.getElementById('tinhHinhTrienKhai_Detail');
                            contentDiv.innerHTML = '';
                        }
                    }
                });
                this.tempKey = common.randomString(10)
                this.isShowModal.detailModal = true
            }
            else {
                this.model = duanDautuModel.newFEModel()
                this.isReadOnly = false
                // show popup
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
        },

        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistDuanDautu({ params: params })
            return res.data

        },
        async validate(model) {
            let isvalid = true
            this.errors = duanDautuModel.errors()
            if (!await this.validateRequired(model.ten)) {
                this.errors.ten = "Nhập tên"
                isvalid = false
            }
            else if (this.code == this.navigateCode.UPDATE && this.model.ten != model.ten) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == this.navigateCode.CREATE) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }

            if (!await this.validateRequired(model.sttBaocao)) {
                this.errors.sttBaocao = "Nhập số thứ tự báo cáo"
                isvalid = false
            }

            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateRequired(model.nguonvonDautuId)) {
                this.errors.nguonvonDautuId = "Chọn nguồn vốn đầu tư"
                isvalid = false
            }
            if (!await this.validateRequired(model.tiendoDautuId)) {
                this.errors.tiendoDautuId = "Chọn tiến độ đầu tư"
                isvalid = false
            }

            if (!await this.validateRequired(model.tongmucDautu)) {
                this.errors.tongmucDautu = "Nhập tổng mức đầu tư"
                isvalid = false
            }
            else if (!await this.validateFloat(model.tongmucDautu)) {
                this.errors.tongmucDautu = "Tổng mức đầu tư phải là kiểu số"
                isvalid = false
            }


            if (model.KHV_idKy) {
                console.log("Hehe")
                if (!await this.validateRequired(model.KHV_idKy)) {
                    this.errors.KHV_idKy = "Chọn kỳ"
                    isvalid = false
                }

                if (!await this.validateRequired(model.KHV_namtruocChuyensang)) {
                    this.errors.KHV_namtruocChuyensang = "Nhập năm trước chuyển sang"
                    isvalid = false
                }
                else if (!await this.validateFloat(model.KHV_namtruocChuyensang)) {
                    this.errors.KHV_namtruocChuyensang = "Năm trước chuyển sang phải là kiểu số"
                    isvalid = false
                }

                if (!await this.validateRequired(model.KHV_vonphankhaiTrongnam)) {
                    this.errors.KHV_vonphankhaiTrongnam = "Nhập vốn phân khai trong năm"
                    isvalid = false
                }
                else if (!await this.validateFloat(model.KHV_vonphankhaiTrongnam)) {
                    this.errors.KHV_vonphankhaiTrongnam = "Vốn phân khai trong năm phải là kiểu số"
                    isvalid = false
                }

                if (!await this.validateRequired(model.KHV_uocnamtruocChuyensang)) {
                    this.errors.KHV_uocnamtruocChuyensang = "Nhập Ước năm trước chuyển sang"
                    isvalid = false
                }
                else if (!await this.validateFloat(model.KHV_uocnamtruocChuyensang)) {
                    this.errors.KHV_uocnamtruocChuyensang = "Ước năm trước chuyển sang phải là kiểu số"
                    isvalid = false
                }
            }





            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = duanDautuModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.duanDautuId = FEmodel.duanDautuId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.duanDautuId = FEmodel.duanDautuId
                sendModel.ten = FEmodel.ten
                sendModel.sttBaocao = FEmodel.sttBaocao
                sendModel.nguonvonDautuId = FEmodel.nguonvonDautuId ? FEmodel.nguonvonDautuId : null
                sendModel.tiendoDautuId = FEmodel.tiendoDautuId ? FEmodel.tiendoDautuId : null
                sendModel.duanDautuLienquanId = FEmodel.duanDautuLienquanId ? FEmodel.duanDautuLienquanId : null
                sendModel.chuDautu = FEmodel.chuDautu
                sendModel.thoigianBatdau = FEmodel.thoigianBatdau
                sendModel.thoigianKetthuc = FEmodel.thoigianKetthuc
                sendModel.sttBaocao = FEmodel.sttBaocao
                sendModel.tongmucDautu = FEmodel.tongmucDautu ? FEmodel.tongmucDautu : null
                sendModel.tinhhinhTrienkhai = FEmodel.tinhhinhTrienkhai
                sendModel.stt = FEmodel.stt
                sendModel.enabled = FEmodel.enabled ? FEmodel.enabled : false


                if (FEmodel.KHV_idKy) {
                    sendModel.KHV_idKy = FEmodel.KHV_idKy ? FEmodel.KHV_idKy : null
                    sendModel.KHV_namtruocChuyensang = FEmodel.KHV_namtruocChuyensang
                    sendModel.KHV_vonphankhaiTrongnam = FEmodel.KHV_vonphankhaiTrongnam
                    sendModel.KHV_uocnamtruocChuyensang = FEmodel.KHV_uocnamtruocChuyensang
                    sendModel.KHV_ghiChu = FEmodel.KHV_ghiChu
                    sendModel.KHV_stt = "0"
                    sendModel.KHV_enabled = true
                }

            }
            return sendModel
        },
        async handleSubmit() {
            if (this.code === this.navigateCode.DELETE) {
                this.csList_MapModel = {
                    title: this.$t('labels.confirmDelete'),
                    confirmLabelButton: this.$t('buttons.confirm'),
                    onClose: null,
                    onSubmit: this.onSubmit,
                    modalContent: "<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>",
                }
                this.isShowModal.confirmDialogModal = true
            }
            else {
                await this.onSubmit()
            }
        },
        async onSubmit() {
            let code = this.code
            this.loadingSubmit = true
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        if(sendModel.KHV_idKy) sendModel.isShowPopup = '0'
                        res = await this.createDuanDautu({ model: sendModel })
                        if (sendModel.KHV_idKy && res && res.data) {
                            //setupData to Send Data KHV
                            let tempDataToSend = {
                                duanDautuId: res.data,
                                idKy: sendModel.KHV_idKy,
                                namtruocChuyensang: sendModel.KHV_namtruocChuyensang,
                                vonphankhaiTrongnam: sendModel.KHV_vonphankhaiTrongnam,
                                uocnamtruocChuyensang: sendModel.KHV_uocnamtruocChuyensang,
                                ghiChu: sendModel.KHV_ghiChu,
                                stt: sendModel.KHV_stt,
                                enabled: sendModel.KHV_enabled,
                            }
                            let res2 = await this.createKehoachVon({ model: tempDataToSend })
                        }
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        if(sendModel.KHV_idKy) sendModel.isShowPopup = '0'
                        res = await this.updateDuanDautu({ model: sendModel })
                        if (sendModel.KHV_idKy && res) {
                            let tempDataToSend = {
                                duanDautuId: sendModel.duanDautuId,
                                idKy: sendModel.KHV_idKy,
                                namtruocChuyensang: sendModel.KHV_namtruocChuyensang,
                                vonphankhaiTrongnam: sendModel.KHV_vonphankhaiTrongnam,
                                uocnamtruocChuyensang: sendModel.KHV_uocnamtruocChuyensang,
                                ghiChu: sendModel.KHV_ghiChu,
                                stt: sendModel.KHV_stt,
                                enabled: sendModel.KHV_enabled,
                            }
                            let res2 = await this.createKehoachVon({ model: tempDataToSend })
                        }

                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteDuanDautu({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteDuanDautu({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreDuanDautu({ model: sendModel })
                    break
                default:
            }
            if (res) {
                this.isShowModal.CRUDModal = false
                await this.getData()
            }
            this.loadingSubmit = false
        },
        //#endregion CRUD

        //#region ListNavigation
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                let tempReConfirmMes = code == this.navigateCode.DELETE ?"<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>những dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>" : null
                this.csList_MapModel = {
                    isReConfirm: code == this.navigateCode.DELETE ? true : false,
                    reConfirmMes: tempReConfirmMes,
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: null,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.isShowModal.confirmDialogModal = true
            }
        },
        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            res = await this.handleListDuanDautu(modelSend)
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.isShowModal.confirmDialogModal = false
            }
        },
        //#endregion ListNavigation

        //#region getCategory
        async getCategory_NguonVonDauTu() {
            let params = {
            }
            let res = await this.getBasicTreeNguonvonDautu({ params: params });

            // Kiểm tra nếu có dữ liệu trả về
            if (res) {
                // Hàm đệ quy để chuyển đổi dữ liệu
                const transformData = (data) => {
                    return data.map(item => {
                        const { nguonvonDautuId, ten, ...rest } = item;
                        const newItem = { id: nguonvonDautuId, label: ten, name: ten, ...rest };

                        // Nếu có children, gọi đệ quy để chuyển đổi
                        if (newItem.children && newItem.children.length > 0) {
                            newItem.children = transformData(newItem.children);
                        }
                        else {
                            delete newItem.children
                        }

                        return newItem;
                    });
                };



                // Chuyển đổi dữ liệu từ API
                let handleRes = transformData(res);
                return handleRes;
            }

            return [];
        },

        async getCategory_TienDoDauTu() {
            let params = {
            }
            let res = await this.getBasicTiendoDautu({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].tiendoDautuId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_DuAnDauTu() {
            let params = {
                "listTiendoDautuId": "1, 2, 3"
            }
            let res = await this.getBasicDuanDautu({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].duanDautuId,
                            label: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return []
        },

        async getCategory_KyKeHoachVon(filterNumber = 0) {
            let params = {
                tableName: tableValue.TCKH_KEHOACHVON,
                loaiKy: 'Y'
            }
            params.filter = filterNumber
            let res = await this.getBasicDMKy({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].idKy,
                            name: res[i].tenKy
                        }
                    )
                }
                return handleRes
            }

            return res
        },
        //#endregion getCategory
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
/* Định dạng cho khung */
.modal-box {
    width: 100%;
    height: auto;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem;
    position: relative;
    padding-top: 1.5rem;
    margin: 10px;
}

.header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: -1rem;
    left: 1rem;
    right: 3rem;
}

.header-box.no-dropdown {
    justify-content: left;
}

.title-box {
    background-color: white;
    font-weight: bold;
    font-size: 1rem;
}

.title2-box {
    background-color: white;
    /* font-weight: bold; */
    font-size: 1rem;
}


.modal-box-content {
    padding: 0 1rem;
}

.divider {
    width: 100%;
    height: 1px;
    background-color: #333;
    margin: 1rem 0;
    /* Khoảng cách trên và dưới */
}


/* Đưa dropdown xuống hàng khi màn hình nhỏ hơn 480px */
@media (max-width: 480px) {
    .modal-box {
        width: 90%;
        padding-top: 3rem;
    }

    .header-box {
        flex-direction: column;
        align-items: flex-start;
        right: unset
            /* Căn trái */
    }

    .title-box {
        font-size: 1rem;
    }

    .title2-box {
        /* font-size: 0.9rem; */
        width: 100%;
        /* Để dropdown chiếm toàn bộ chiều rộng */
    }

    .modal-box-content {
        font-size: 0.9rem;
        padding-top: 1rem;
    }
}

.select2-container--bootstrap4 .select2-selection {
    min-width: 8rem;
    /* Đặt chiều rộng tối thiểu theo ý muốn */
}
</style>